import React, { useState } from 'react'
import styled from 'styled-components'

// Components
import { LoaderButton } from '../../../_components/LoaderButton'

const S_ChargebackConfirmModal = styled.div`
  p {
    margin: 20px 0;
  }

  .actions-row {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .refund-button {
      background-color: red;
      opacity: 0.75;
      &:hover {
        opacity: 1;
      }
      &:disabled {
        opacity: 0.25;
      }
    }
  }
`

export const ChargebackConfirmModal = (props) => {
  const { onConfirmChargeback, cancelConfirm } = props
  const [isLoading, setIsLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)

  const executeChargeback = () => {
    setIsLoading(true)
    setDisabled(true)
    onConfirmChargeback()
  }

  return (
    <S_ChargebackConfirmModal>
      <h2>Confirm Chargeback</h2>
      <p>Are you sure you want to chargeback this invoice?</p>
      <div className="actions-row">
        <LoaderButton disabled={disabled} isLoading={false} onClick={cancelConfirm} text="Cancel" />
        <LoaderButton className={`refund-button`} isLoading={isLoading} onClick={executeChargeback} text="Confirm" />
      </div>
    </S_ChargebackConfirmModal>
  )
}
